import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { Router } from '@angular/router';
import { Settings } from '../app.settings.model';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ErrorDialogService {

  private settings: Settings;

  constructor(private router: Router, public dialog: MatDialog, private appSettings: AppSettings) {
    this.settings = appSettings.settings;
  }

  openDialog(data): MatDialogRef<ErrorDialogComponent, any> {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: data
    });

    return dialogRef;
    // dialogRef.afterClosed().subscribe(result => {
    //   this.router.navigate(['/login']);
    // });
  }
}
